"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AdaptiveCardBuilder = require("./AdaptiveCardBuilder");

var _CommonCard = _interopRequireDefault(require("./CommonCard"));
/* eslint react/no-array-index-key: "off" */


var ImageContent = _botframeworkWebchatComponent.Components.ImageContent,
    VideoContent = _botframeworkWebchatComponent.Components.VideoContent;

var AnimationCardAttachment =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AnimationCardAttachment, _React$Component);

  function AnimationCardAttachment(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AnimationCardAttachment);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AnimationCardAttachment).call(this, props));
    _this.buildCard = (0, _memoizeOne.default)(function (adaptiveCards, content, styleOptions) {
      var builder = new _AdaptiveCardBuilder.AdaptiveCardBuilder(adaptiveCards, styleOptions);
      (content.images || []).forEach(function (image) {
        return builder.addImage(image.url, null, image.tap);
      });
      builder.addCommon(content);
      return builder.card;
    });
    return _this;
  }

  (0, _createClass2.default)(AnimationCardAttachment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adaptiveCardHostConfig = _this$props.adaptiveCardHostConfig,
          adaptiveCards = _this$props.adaptiveCards,
          attachment = _this$props.attachment,
          _this$props$attachmen = _this$props.attachment;
      _this$props$attachmen = _this$props$attachmen === void 0 ? {} : _this$props$attachmen;
      var _this$props$attachmen2 = _this$props$attachmen.content;
      _this$props$attachmen2 = _this$props$attachmen2 === void 0 ? {} : _this$props$attachmen2;
      var _this$props$attachmen3 = _this$props$attachmen2.media,
          media = _this$props$attachmen3 === void 0 ? [] : _this$props$attachmen3,
          styleSet = _this$props.styleSet;
      return _react.default.createElement("div", {
        className: styleSet.animationCardAttachment
      }, _react.default.createElement("ul", {
        className: "media-list"
      }, media.map(function (_ref, index) {
        var _ref$profile = _ref.profile,
            profile = _ref$profile === void 0 ? '' : _ref$profile,
            url = _ref.url;
        return _react.default.createElement("li", {
          key: index
        }, /\.gif$/i.test(url) ? _react.default.createElement(ImageContent, {
          alt: profile,
          src: url
        }) : _react.default.createElement(VideoContent, {
          alt: profile,
          src: url
        }));
      })), _react.default.createElement(_CommonCard.default, {
        adaptiveCardHostConfig: adaptiveCardHostConfig,
        adaptiveCards: adaptiveCards,
        attachment: attachment
      }));
    }
  }]);
  return AnimationCardAttachment;
}(_react.default.Component);

AnimationCardAttachment.propTypes = {
  adaptiveCardHostConfig: _propTypes.default.any.isRequired,
  adaptiveCards: _propTypes.default.any.isRequired,
  attachment: _propTypes.default.shape({
    content: _propTypes.default.shape({
      media: _propTypes.default.arrayOf(_propTypes.default.shape({
        profile: _propTypes.default.string,
        url: _propTypes.default.string.isRequired
      })).isRequired
    }).isRequired
  }).isRequired,
  styleSet: _propTypes.default.shape({
    animationCardAttachment: _propTypes.default.any.isRequired,
    options: _propTypes.default.any.isRequired
  }).isRequired
};

var _default = (0, _botframeworkWebchatComponent.connectToWebChat)(function (_ref2) {
  var styleSet = _ref2.styleSet;
  return {
    styleSet: styleSet
  };
})(AnimationCardAttachment);

exports.default = _default;